export default function LeadCaptureModule() {
  return (
    <section id="lead-capture" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                <i className="ri-focus-3-line text-teal-500" />
              </div>
              <span className="text-xs font-semibold uppercase tracking-widest text-teal-600">Module 01</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight mb-4">
              Capture Every Lead —<br />
              <span className="bg-gradient-to-r from-teal-500 to-emerald-500 bg-clip-text text-transparent">From Every Source</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Never miss a potential customer. TreWaz collects leads from your website enquiry forms, WhatsApp click-to-chat links, and any other source you use — and automatically adds them to your CRM with all details captured.
            </p>
            <ul className="flex flex-col gap-4">
              {[
                { icon: 'ri-code-s-slash-line', title: 'Embeddable website widget', desc: 'A lightweight form you drop onto any website page. Visitors fill it in, leads appear instantly in your dashboard.' },
                { icon: 'ri-whatsapp-line', title: 'WhatsApp click-to-chat', desc: 'Share your branded WhatsApp link anywhere. When a customer taps it, the AI starts the conversation and captures the lead.' },
                { icon: 'ri-links-line', title: 'Multi-source tracking', desc: 'Leads from Instagram, Facebook, referrals, walk-ins — log them all. Every lead gets tagged with its source for reporting.' },
                { icon: 'ri-user-add-line', title: 'Instant CRM entry', desc: 'No copy-paste. Lead details (name, contact, destination, travel dates) auto-populate in the CRM pipeline the moment they come in.' },
              ].map((item) => (
                <li key={item.title} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg shrink-0 mt-0.5">
                    <i className={`${item.icon} text-teal-600 text-sm`} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-800 mb-0.5">{item.title}</p>
                    <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Visual mockup */}
          <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6 space-y-4">
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-semibold text-gray-700">New Lead Captured</p>
              <span className="text-[10px] bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full font-medium">Live</span>
            </div>
            {/* Simulated lead cards */}
            {[
              { name: 'Sara Al-Farsi', dest: 'Bali Honeymoon', dates: 'Apr 12 – Apr 22', source: 'Website Form', budget: '$3,500', status: 'New', color: 'teal' },
              { name: 'Ahmed Khalil', dest: 'Dubai Family Trip', dates: 'May 5 – May 12', source: 'WhatsApp', budget: '$6,200', status: 'Qualified', color: 'emerald' },
              { name: 'Nadia Torres', dest: 'Europe Group Tour', dates: 'Jun 1 – Jun 14', source: 'Instagram', budget: '$9,000', status: 'New', color: 'teal' },
            ].map((lead) => (
              <div key={lead.name} className="bg-white rounded-xl border border-gray-100 p-4">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center">
                      <span className="text-[10px] font-bold text-white">{lead.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-gray-800">{lead.name}</p>
                      <p className="text-[11px] text-gray-400">{lead.dest}</p>
                    </div>
                  </div>
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${lead.status === 'New' ? 'bg-teal-50 text-teal-600' : 'bg-emerald-50 text-emerald-600'}`}>
                    {lead.status}
                  </span>
                </div>
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="flex items-center gap-1 text-[11px] text-gray-400">
                    <i className="ri-calendar-line text-teal-400" />{lead.dates}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] text-gray-400">
                    <i className="ri-money-dollar-circle-line text-emerald-400" />{lead.budget}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] text-gray-400">
                    <i className="ri-map-pin-line text-teal-400" />{lead.source}
                  </span>
                </div>
              </div>
            ))}
            <div className="flex items-center gap-2 pt-1">
              <div className="flex-1 h-[1px] bg-gray-100" />
              <span className="text-[10px] text-gray-400">3 leads captured today</span>
              <div className="flex-1 h-[1px] bg-gray-100" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
